<template>
    <select class="mapboxgl-ctrl-geolocate" v-model="selection" @change="onChange($event)">
        <option v-for="year in years" v-bind:key="year">{{ year }}</option>
    </select>
</template>

<script>
export default {
    props: ['selection'],
    data() {
        return {
            "years": []
        }
    },
    mounted() {
        this.axios.get('db/years.json').then((response) => {
            this.years=response.data;
        })
        /*  this.$root.$on("ici", (year) => {
          console.log(year);
        })
        this.$root.$emit("ici", this.selected) */
    },
    methods: {
        onChange(e) {
            // this.$root.$emit('year', this.selected)
            this.$emit('selection', this.selection)
        }
    }
}
</script>

<style>

</style>